import "./order-tabs-loading-overlay.scss";

import classNames from "classnames";
import { FunctionComponent } from "react";

interface OrderInProcessingProps {
	label?: string;
	customHeight?: string | number;
	verticalCenter?: boolean;
}

export const OrderTabsLoadingOverlay: FunctionComponent<
	OrderInProcessingProps
> = ({ label = "loading orders", customHeight, verticalCenter }) => {
	return (
		<div
			onClick={(e: React.MouseEvent<HTMLDivElement>) => {
				e.preventDefault();
				e.stopPropagation();
			}}
			className="orders-loading"
			style={customHeight ? { height: customHeight } : {}}
		>
			<div
				className={classNames("orders-loading-label", {
					"vertical-center": verticalCenter,
				})}
			>
				<img src="/images/no_orders.png" />
				{label}
			</div>
		</div>
	);
};
